export default __webpack_public_path__ + "static/media/The Eye of the Bretheren.d6a2ef1f.jpg";